import { render, staticRenderFns } from "./RecoverPasswordMessage.vue?vue&type=template&id=1f5ebd48&"
import script from "./RecoverPasswordMessage.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports